"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../utils");
const Tooltip = ({ content, direction = 'top', children, arrow = false, className = '', arrowClassName = '', ...rest }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const showTooltip = () => setIsVisible(true);
    const hideTooltip = () => setIsVisible(false);
    const toggleTooltip = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            setIsVisible((prev) => !prev);
        }
    };
    const directionClasses = {
        top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
        'top-start': 'bottom-full left-0 mb-2',
        'top-end': 'bottom-full right-0 mb-2',
        'bottom-start': 'top-full left-0 mt-2',
        'bottom-end': 'top-full right-0 mt-2',
    };
    const arrowClasses = {
        top: 'absolute -bottom-1 left-1/2 transform -translate-x-1/2 border-t-brandBlack border-t-4 border-x-transparent border-x-4 border-b-0',
        bottom: 'absolute -top-1 left-1/2 transform -translate-x-1/2 border-b-brandBlack border-b-4 border-x-transparent border-x-4 border-t-0',
        left: 'absolute -right-1 top-1/2 transform -translate-y-1/2 border-l-brandBlack border-l-4 border-y-transparent border-y-4 border-r-0',
        right: 'absolute -left-1 top-1/2 transform -translate-y-1/2 border-r-brandBlack border-r-4 border-y-transparent border-y-4 border-l-0',
        'top-start': 'absolute -bottom-1 left-2 transform border-t-brandBlack border-t-4 border-x-transparent border-x-4 border-b-0',
        'top-end': 'absolute -bottom-1 right-2 transform border-t-brandBlack border-t-4 border-x-transparent border-x-4 border-b-0',
        'bottom-start': 'absolute -top-1 left-2 transform border-b-brandBlack border-b-4 border-x-transparent border-x-4 border-t-0',
        'bottom-end': 'absolute -top-1 right-2 transform border-b-brandBlack border-b-4 border-x-transparent border-x-4 border-t-0',
    };
    return (react_1.default.createElement("div", { className: "relative inline-block", ...rest },
        react_1.default.createElement("div", { className: "cursor-pointer", onMouseEnter: showTooltip, onMouseLeave: hideTooltip, onKeyDown: toggleTooltip, role: "button", tabIndex: 0, "aria-describedby": "tooltip" }, children),
        isVisible && (react_1.default.createElement("div", { id: "tooltip", role: "tooltip", className: (0, utils_1.cn)('absolute z-10 px-2 py-1 w-24 text-sm text-white bg-brandBlack rounded shadow-md transition-opacity duration-200', directionClasses[direction], className, { 'opacity-100': isVisible, 'opacity-0': !isVisible }) },
            content,
            arrow && (react_1.default.createElement("div", { className: (0, utils_1.cn)('w-0 h-0', arrowClasses[direction], arrowClassName) }))))));
};
exports.Tooltip = Tooltip;
